import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-248">
      <div className="max-w-4xl mx-auto text-center" data-id="element-249">
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-8 text-center uppercase tracking-wider" data-id="element-250">
          🏆 EL SISTEMA N°1 PARA ENTRENADORES DE BOXEO EN HABLA HISPANA
        </h2>

        <div className="mb-2" data-id="element-251">
          <span className="text-white text-3xl sm:text-5xl font-black tracking-tight" data-id="element-252">
            🥊 EDULABS™
          </span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-[#F97316] mb-4" data-id="element-253">
          MEGAPACK BOXEO LISTO
        </h2>
        <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-6 leading-snug" data-id="element-254">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </h3>
        <p className="text-white text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-255">
          300+ páginas · 140 clases modelo · Round-by-Round · Técnica · Potencia
          · Defensa · Táctica · Sparring · Gestión · Comunicación. Funciona
          desde mañana. En cualquier país. En cualquier gimnasio.
        </p>

        <div className="relative mx-auto mb-10 max-w-lg" data-id="element-256">
          <div className="flex items-end justify-center gap-2 sm:gap-3" data-id="element-257">
            {[{
            color: '#1565C0',
            label: 'Principiante'
          }, {
            color: '#2E7D32',
            label: 'Intermedio'
          }, {
            color: '#E65100',
            label: 'Avanzado'
          }, {
            color: '#6A1B9A',
            label: 'Técnica'
          }, {
            color: '#37474F',
            label: 'Defensa'
          }, {
            color: '#BF360C',
            label: 'Gestión'
          }].map((item, i) => <div key={i} className="flex flex-col items-center flex-1 min-w-0" data-id="element-258">
                <div className="w-full aspect-[3/4] rounded-md sm:rounded-lg shadow-2xl" style={{
              backgroundColor: item.color,
              border: '2px solid #F97316'
            }} data-id="element-259" />
                <span className="text-white text-[9px] sm:text-xs font-bold mt-1.5 text-center leading-tight" data-id="element-260">
                  {item.label}
                </span>
              </div>)}
          </div>
          <div className="mt-3 flex justify-center" data-id="element-261">
            <span className="bg-[#F97316] text-black font-black text-[10px] sm:text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-262">
              6 TOMOS COMPLETOS
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 mt-12 w-full max-w-lg mx-auto" data-id="element-263">
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-264">
            ✅ Por nivel y progresión bimestral
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-265">
            ✅ 140 clases completas Round-by-Round
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-266">
            ✅ Evaluaciones + seguimiento individual
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-267">
            ✅ Técnica + Potencia + Defensa + Táctica + Sparring
          </span>
        </div>
      </div>
    </section>;
}